import { denim, white } from './colors';
export var palette = {
    mode: 'light',
    primary: {
        main: denim,
        contrastText: white,
        hover: denim,
        active: denim,
    },
    secondary: {
        main: '#ebf0f5',
        contrastText: '#23292d', // tundora
    },
    text: {
        primary: '#23292d',
        hint: '#9eafbe',
        secondary: '#404c52',
        disabled: 'rgba(35,41,45,0.4)', // tundora (40%)
    },
    background: {
        default: '#f1f5f8',
        paper: '#ffffff', // white
    },
    error: {
        main: '#b4061f',
        contrastText: '#ffffff', // white
    },
    warning: {
        main: '#fad21c',
        contrastText: '#23292d', // tundora
    },
    info: {
        main: '#3aceee',
        contrastText: '#23292d', // tundora
    },
    success: {
        main: '#1d8b3d',
        contrastText: '#ffffff', // white
    },
    divider: '#becdd7',
    action: {
        active: '#353d43',
        hover: 'rgba(194,215,235,0.7)',
        selected: '#387cbe', // scienceblue
    },
    focusRing: {
        main: '#000',
    },
};
